import React from "react";
import parse from "html-react-parser";

export default function WelcomeSection({ sectionTitle, videoUrl, data }) {
  const item = data[0];
  
  return (
    <section className="cs_about_new_welcome">
      <div className="container">
        <div className="cs_welcome_row">
          <div className="cs_welcome_img_col">
            <div className="cs_welcome_arch_container">
              {videoUrl ? (
                <video src={videoUrl} autoPlay loop muted playsInline className="cs_welcome_media" />
              ) : (
                <img src="/images/home_1/AboutJBpIVF.png" alt="About Pluro Jabalpur IVF" className="cs_welcome_media" />
              )}
            </div>
          </div>
          <div className="cs_welcome_content_col">
            <div className="cs_welcome_text_wrapper">
              {sectionTitle && (
                <h2 className="cs_welcome_title">
                  {parse(sectionTitle)}
                </h2>
              )}
              <div className="cs_welcome_text">
                <p>{item.subTitle}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
